import { useOutletContext } from "react-router";

import { ClientTabBase } from "@shared";

import { ClientDetailResponse } from "@/api";
import { ClientStatusWidget } from "@/pages/clients/client/components/client-status-widget/ClientStatusWidget";

export function PersonalBankruptcyPetitionTab() {
  const client = useOutletContext<ClientDetailResponse>();

  return <ClientTabBase navigation={<></>} navigationFooter={<ClientStatusWidget client={client} />}></ClientTabBase>;
}
